module.exports = __webpack_public_path__ + "img/account.1559b834.svg";